import React, {useContext, useState} from 'react';
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import {FormattedMessage, injectIntl} from "react-intl";
import Column from "@meridian/components/column";
import Text from "@amzn/meridian/text";
import {AsmlDeviceOverviewContext} from "../context/AsmlDeviceOverviewContext";
import Alert from "@amzn/meridian/alert"
import Select, {SelectOption} from "@amzn/meridian/select";
import {
    validateNewAsmlDevice
} from "../../../util/Validations";
import {getLocalizedMessage} from "../../../util/Localization";

const AddAsmlSingleDeviceModal = (props) => {

    const {formatMessage} = props.intl;
    const {open, setOpen, selectedInductCameraMac,
        selectedPrinterMac, selectedVerificationCameraMac} = props;
    const {dispatch} = useContext(AsmlDeviceOverviewContext);

    // Visual controls
    const [showAlert, setShowAlert] = useState(false);

    // States
    const [inductCameraMac, setInductCameraMac] = useState("");
    const [printerMac, setPrinterMac] = useState("");
    const [verificationCameraMac, setVerificationCameraMac] = useState("");

    // Error states
    const [inductCameraMacErr, setInductCameraMacErr] = useState(false);
    const [printerMacErr, setPrinterMacErr] = useState(false);
    const [verificationCameraMacErr, setVerificationCameraMacErr] = useState(false);
    const [availableInductCameraMacAddressList, setAvailableInductCameraMacAddressList] = useState(props.availableInductCameraMacAddressList);
    const [availablePrinterMacAddressList, setAvailablePrinterMacAddressList] = useState(props.availablePrinterMacAddressList);
    const [availableVerificationCameraMacAddressList, setAvailableVerificationCameraMacAddressList] = useState(props.availableVerificationCameraMacAddressList);
    const [originalInductCameraMac, setOriginalInductCameraMac] = useState("");
    const [originalPrinterMac, setOriginalPrinterMac] = useState("");
    const [originalVerificationCameraMac, setOriginalVerificationCameraMac] = useState("");

    let stateValues = {
        inductCameraMac: inductCameraMac,
        printerMac: printerMac,
        verificationCameraMac: verificationCameraMac,
        originalInductCameraMac: originalInductCameraMac,
        originalPrinterMac: originalPrinterMac,
        originalVerificationCameraMac: originalVerificationCameraMac
    }

    const onCloseModal = () => {
        setOpen(false)
        setInductCameraMac("")
        setPrinterMac("")
        setVerificationCameraMac("")
        clearAssetDetailErrors();
        setShowAlert(false);
    }


    function clearAssetDetailErrors() {
        setInductCameraMacErr(false);
        setPrinterMacErr(false);
        setVerificationCameraMacErr(false);
    }
    const onClickConfirm = (stateValues) => {
        if (validateNewAsmlDevice(stateValues)) {
            setShowAlert(false);
            setOpen(false);
            if(selectedInductCameraMac) {
                updateData(stateValues)
            } else {
                addData(stateValues)
            }
            setInductCameraMac("")
            setPrinterMac("")
            setVerificationCameraMac("")
        } else {
            setShowAlert(true);
        }
    };

    const prefill = (value) => {
        if (selectedInductCameraMac) {
            setInductCameraMac(selectedInductCameraMac);
            setAvailableInductCameraMacAddressList(props.editAvailableInductCameraMacAddressList);
            setOriginalInductCameraMac(selectedInductCameraMac)
            setPrinterMac(selectedPrinterMac);
            setAvailablePrinterMacAddressList(props.editAvailablePrinterMacAddressList);
            setOriginalPrinterMac(selectedPrinterMac)
            setVerificationCameraMac(selectedVerificationCameraMac);
            setAvailableVerificationCameraMacAddressList(props.editAvailableVerificationCameraMacAddressList);
            setOriginalVerificationCameraMac(selectedVerificationCameraMac)
        } else {
            setAvailableInductCameraMacAddressList(props.availableInductCameraMacAddressList);
            setAvailablePrinterMacAddressList(props.availablePrinterMacAddressList)
            setAvailableVerificationCameraMacAddressList(props.availableVerificationCameraMacAddressList)
        }
    }

    const addData = (stateValues) => {
        dispatch({type: 'ADD_DEVICE_DATA', data: {dispatcher: dispatch, stateValues: stateValues}})
    }

    const updateData = (stateValues) => {
        dispatch({type: 'UPDATE_DEVICE_DATA', data: {dispatcher: dispatch, stateValues: stateValues}})
    }

    return (
        <Modal
            title={formatMessage({id: "device.add_device_button_modal"})}
            open={open}
            onOpen={() => prefill(selectedInductCameraMac)}
            onClose={onCloseModal}
            scrollContainer="viewport"
            closeLabel="Close"
            bodySpacingInset="medium"
            width="100%">
            <Column spacing={"medium"} spacingInset={"medium"}>
                <Column spacing="200">
                    <Text tag="label" type="b200" color="primary" htmlFor="mac-input">
                        {getLocalizedMessage({intl: props.intl, stringId: 'modal.induct_camera_mac'})}
                    </Text>
                    {<Select
                        value={inductCameraMac}
                        onChange={(value) => {
                            setInductCameraMac(value);
                            setOriginalInductCameraMac(selectedInductCameraMac)
                        }}
                        onBlur={() => setInductCameraMacErr(!inductCameraMac)}
                        placeholder={getLocalizedMessage({intl: props.intl, stringId: 'modal.select_induct_camera_mac'})}
                        error={inductCameraMacErr}
                        width="100%">
                        {
                            availableInductCameraMacAddressList.map((macAddress) => (<SelectOption key={macAddress} value={macAddress} label={macAddress}/>))
                        }
                    </Select>}
                </Column>
                <Column spacing="200">
                    <Text tag="label" type="b200" color="primary" htmlFor="mac-input">
                        {getLocalizedMessage({intl: props.intl, stringId: 'modal.printer_mac'})}
                    </Text>
                    <Select
                        value={printerMac}
                        onChange={(value) => {
                            setPrinterMac(value);
                            setOriginalPrinterMac(selectedPrinterMac)
                        }}
                        onBlur={() => setPrinterMacErr(!printerMac)}
                        placeholder={getLocalizedMessage({intl: props.intl, stringId: 'modal.select_printer_mac'})}
                        error={printerMacErr}
                        width="100%">
                        {
                            availablePrinterMacAddressList.map((macAddress) => (<SelectOption key={macAddress} value={macAddress} label={macAddress}/>))
                        }
                    </Select>
                </Column>
                <Column spacing="200">
                    <Text tag="label" type="b200" color="primary" htmlFor="mac-input">
                        {getLocalizedMessage({intl: props.intl, stringId: 'modal.verification_camera_mac'})}
                    </Text>
                    <Select
                        value={verificationCameraMac}
                        onChange={(value) => {
                            setVerificationCameraMac(value);
                            setOriginalVerificationCameraMac(selectedVerificationCameraMac)
                        }}
                        onBlur={() => setVerificationCameraMacErr(!verificationCameraMac)}
                        placeholder={getLocalizedMessage({intl: props.intl, stringId: 'modal.select_verification_camera_mac'})}
                        error={verificationCameraMacErr}
                        width="100%">
                        {
                            availableVerificationCameraMacAddressList.map((macAddress) => (<SelectOption key={macAddress} value={macAddress} label={macAddress}/>))
                        }
                    </Select>
                </Column>
            </Column>
            <ModalFooter>
                <Column>
                    {showAlert && <Alert type="warning" size="small">
                        <FormattedMessage id="alert.missingfields"
                                          defaultMessage="Please enter all fields in correct format!"/>
                    </Alert>}
                </Column>
                <Row alignmentHorizontal="right" widths="fit">
                    <Button type="secondary" size="medium" onClick={onCloseModal}>
                        <FormattedMessage id="modal.cancel" defaultMessage="Cancel"/>
                    </Button>
                    <Button type="primary" size="medium"
                            onClick={() => onClickConfirm(stateValues)}>
                        {selectedInductCameraMac ? <FormattedMessage id="modal.confirmEdit" defaultMessage="Confirm edit"/> :
                            <FormattedMessage id="modal.confirmAdd" defaultMessage="Confirm add"/>
                        }
                    </Button>
                </Row>
            </ModalFooter>
        </Modal>
    )
}

export default injectIntl(AddAsmlSingleDeviceModal);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asmldevice/modal/AddAsmlSingleDeviceModal.js